import { cn, ScrollArea } from "web-design-system";
import { cva } from "class-variance-authority";

const containerVariants = cva("", {
  variants: {
    variant: {
      default:
        "bg-gradient-to-b from-slate-200 via-slate-50 dark:from-slate-800 dark:via-slate-900 via-10% to-background",
      error: "bg-gradient-to-b from-orange-50 via-white via-20% to-background",
      success: "bg-gradient-to-b from-green-50 via-white via-20% to-background",
      none: "bg-background",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export function MobileViewContainer({
  children,
  variant,
}: {
  children: React.ReactNode;
  variant?: "default" | "error" | "success" | "none";
}) {
  return (
    <div className="flex h-dvh w-dvw flex-col items-center justify-center bg-background">
      <ScrollArea className="md:border md:rounded-lg md:shadow-xl h-full w-full shadow-none rounded-none md:h-[700px] md:w-[500px]">
        <div
          className={cn(
            "flex rounded-lg flex-col relative w-full",
            containerVariants({ variant })
          )}
        >
          {children}
        </div>
      </ScrollArea>
    </div>
  );
}
